import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../../../../../i18n';
import Notification from '../../Notification';
import useAttendanceInProgressNotification from './vm';

export interface AttendanceInProgressNotificationProps {
  className?: string;
}

const AttendanceInProgressNotification = ({ className }: AttendanceInProgressNotificationProps) => {
  const { t } = useTranslation([i18nNS.CLASS]);

  const { latestFailure } = useAttendanceInProgressNotification();

  if (!latestFailure) return null;

  return (
    <Notification className={className}>
      {t('num_students_have_the_app_closed', {
        ns: i18nNS.CLASS,
        number: latestFailure.unresponsiveAttendees,
      })}
    </Notification>
  );
};

export default AttendanceInProgressNotification;
